import { useApi } from '@/api';
import { ChartSkeleton, ChartTimeFilter } from '@/components';
import { DisplaySwitch, Flex } from '@blockanalitica/ui';
import { useMemo, useState } from 'react';
import HistoricGraphs from './HistoricGraphs';

export default function HistoricTabs({
  ilk,
  collateralSymbol,
  collateralAddress
}) {
  const [activeDisplayOption, setActiveDisplayOption] = useState('ink');
  const [chartDaysAgo, setChartDaysAgo] = useState('30');

  const displayOptions = useMemo(
    () => [
      { key: 'ink', value: 'Locked' },
      { key: 'debt', value: 'Borrow' }
      // { key: 'weighted_cr', value: 'Weighted Collateral Ratio' }
    ],
    []
  );

  const [data, error] = useApi({
    url: `/groups/staked/ilks/${ilk}/historic/`,
    queryParams: {
      days_ago: chartDaysAgo
    }
  });

  const [LSESKYdata, LSESKYerror] = useApi({
    url: `/lsev2/historic/`,
    queryParams: {
      days_ago: chartDaysAgo
    }
  });

  if (error || LSESKYerror) {
    throw error;
  }

  const timeFilter = useMemo(
    () => (
      <ChartTimeFilter activeOption={chartDaysAgo} onChange={setChartDaysAgo} />
    ),
    [chartDaysAgo]
  );

  if (data && LSESKYdata) {
    const result = data;
    return (
      <Flex flexDirection="column" gap="xs">
        <DisplaySwitch
          data={displayOptions}
          activeOption={activeDisplayOption}
          onChange={setActiveDisplayOption}
        />

        <HistoricGraphs
          data={result}
          type={activeDisplayOption}
          collateralSymbol={collateralSymbol}
          collateralAddress={collateralAddress}
          timeFilter={timeFilter}
          chartDaysAgo={chartDaysAgo}
        />
      </Flex>
    );
  }

  return <ChartSkeleton />;
}
